<template>
  <editor-content :editor="editor" />
</template>

<script>
import { EditorContent } from '@tiptap/vue-3';

export default {
  components: {
    EditorContent,
  },

  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },

  emits: ['update:modelValue'],

  setup() {},
};
</script>
